import {
    GoogleAuthProvider,
    getAdditionalUserInfo,
    signInWithPopup,
    onAuthStateChanged as _onAuthStateChanged,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    createUserWithEmailAndPassword,
    sendEmailVerification,
} from "firebase/auth";

import { auth } from "./firebase";
import { initializeUserLegacyAccess } from "./database";

export function onAuthStateChanged(cb) {
    return _onAuthStateChanged(auth, cb);
}

export async function signInWithGoogle() {
    const provider = new GoogleAuthProvider();

    try {
        const result = await signInWithPopup(auth, provider);
        if (getAdditionalUserInfo(result)?.isNewUser) {
            await initializeUserLegacyAccess(result.user);
        }
    } catch (error) {
        console.error("Error signing in with Google", error);
    }
}

export async function signOut() {
    try {
        return auth.signOut();
    } catch (error) {
        console.error("Error signing out with Google", error);
    }
}

export async function signInWithEmail(email, password, setError) {
    try {
        await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
        setError("Credenciais invÃ¡lidas.");
    }
}

export async function createUserWithEmail(name, email, password, setError) {
    try {
        const newUser = await createUserWithEmailAndPassword(auth, email, password);
        await initializeUserLegacyAccess(newUser.user, { name, email });
        sendVerification(newUser.user);
    } catch (error) {
        setError("NÃ£o foi possÃ­vel criar a conta com esses dados.");
    }
}

export async function sendPasswordReset(email) {
    try {
        await sendPasswordResetEmail(auth, email);
    } catch (error) {
        console.error("Error recovering password", error);
    }
}

export async function sendVerification(user) {
    try {
        await sendEmailVerification(user);
    } catch (error) {
        console.error("Erro ao enviar e-mail de verificaÃ§Ã£o", error);
    }
}
